import Link from "next/link";
import Container from "@/components/ui/container";
import { siteContent } from "@/lib/data";

export default function TopBar() {
  const { brand } = siteContent;
  const phoneRaw = brand.phone.replace(/\s+/g, "");
  return (
    <div className="bg-[color:var(--color-sale)] text-white">
      <Container className="flex h-9 items-center justify-between gap-4 text-[12px] sm:text-[13px]">
        <div className="flex items-center gap-2 truncate">
          <span className="text-white/80">For sales &amp; advice call</span>
          <a href={`tel:${phoneRaw}`} className="font-semibold hover:underline underline-offset-4">
            {brand.phone}
          </a>
        </div>
        <ul className="hidden sm:flex items-center gap-5 shrink-0">
          <li>
            <Link href="/contact" className="hover:underline underline-offset-4">
              Contact Us
            </Link>
          </li>
          <li>
            <Link href="/contact" className="hover:underline underline-offset-4">
              Returns
            </Link>
          </li>
          <li>
            <Link href="/contact" className="hover:underline underline-offset-4">
              Track Order
            </Link>
          </li>
        </ul>
      </Container>
    </div>
  );
}
